(function (angular) {
    'use strict';

    angular.module('widget')
        /**
         *
         */
        .controller('widgetConfigCtrl',
        ['$scope', '$stateParams', 'portalConfig', 'growlService', '$uibModalInstance', '$timeout', function ($scope, $stateParams, portalConfig, growlService, $uibModalInstance, $timeout) {

            $timeout(function () {
                var cm = angular.element(document.querySelector('.CodeMirror'));
                cm[0].CodeMirror.refresh();
            }, 0);

            $scope.cancel = function () {
                $uibModalInstance.close('cancel');
            };

            $scope.select = {
                authCallback: false
            };

            $scope.editorOptions = {
                lineWrapping: true,
                lineNumbers: true,
                theme: "panda-syntax",
                mode: { name: "javascript", json: true }
            };
            $scope.verifyConfig = verifyConfig;
            var urlBase;
            var authCallback;
            var comapiConfig;

            if (portalConfig.environmentPrefix == 'production') {
                urlBase = '';
            } else {
                urlBase = ",\n\         urlBase: '" + portalConfig.urlBase + "'";
            }

            verifyConfig();

            $scope.copyToClipboard = function () {
                var copyTextarea = document.querySelector('.widget-script');
                copyTextarea.select();
                try {
                    document.execCommand('copy');
                    growlService.success('Snippet copied to clipboard');
                } catch (err) {
                    growlService.danger("Snippet not copied, try manualy");
                }
            };

            function verifyConfig() {
                if ($scope.authCallback) {
                    authCallback = ",\n\         authCallback: function (nonce, answerAuthenticationChallenge){\n\ " +
                        "           // TODO: generate a jwt and return \n\ " +
                        "           var jwt = ''; \n\ " +
                        "           answerAuthenticationChallenge(jwt); \n\ " +
                        "       }"
                        ;
                } else {
                    authCallback = "";
                }
                comapiConfig = "        apiSpace: '" + $stateParams.pickedApiSpaceId + "'" +
                    urlBase + authCallback;
                $scope.script = "\
<script>\n\
    window.comapiConfig = " + "{\n\ " +
                    comapiConfig +
                    " \n\    };\n\ " +
                    "   (function(d, s, id){\n\
        var js, cjs = d.getElementsByTagName(s)[0];\n\
        if (d.getElementById(id)) {return;}\n\
        js = d.createElement(s); js.id = id;\n\
        js.src = '//cdn.dnky.co/widget/bootstrap.js';\n\
        cjs.parentNode.insertBefore(js, cjs);\n\
    }(document, 'script', 'comapi-widget'));\n\
</script>";
            }

            //  for testing purposes
            $scope.verifyConfig = verifyConfig;
        }]);


})(window.angular);
